import {Skeleton} from "@project/design-system-web";
import {PageSubContainer} from "@project/layouts";

export function ExpedientOptionsPending() {
  return (
    <PageSubContainer>
      <div className="grid gap-4 md:grid-cols-2">
        {Array.from({length: 2}).map((_, index) => (
          <div className="rounded-2xl border p-4" key={index}>
            <div className="flex items-start justify-between gap-4">
              <Skeleton className="h-7 w-40 rounded-md" />
              <Skeleton className="h-10 w-32 rounded-md" />
            </div>
            <div className="mt-4 grid gap-3">
              {Array.from({length: 6}).map((__, fieldIndex) => (
                <div key={fieldIndex}>
                  <Skeleton className="mb-1 h-4 w-24 rounded-md" />
                  <Skeleton className="h-5 w-32 rounded-md" />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </PageSubContainer>
  );
}
